import { IApplicationState } from '../../types/redux';

export function getMortgageBanner(state: IApplicationState) {
  return state.specialPromosBlocks.mortgageBanner;
}
